const getId = (event, { asInt } = { asInt: true }) => {
  const { id } = event.currentTarget.dataset;
  if (asInt) {
    return parseInt(id, 10);
  }
  return id;
};

export default getId;
